<template>
    <div class="row-actions-menu" :class="{'is-open': open}">
        <a href ref="trigger" class="btn btn-icon dropdown-toggle row-actions-trigger" role="button" @click.prevent.stop="toggle">
            <i class="fas fa-ellipsis-v"></i><span class="sr-only">More Actions</span>
        </a>
        <div v-if="open" ref="menu" class="dropdown-menu show has-icons row-actions-dropdown">
            <template v-for="(item, idx) in items" :key="idx">
                <div v-if="item.divider" class="dropdown-divider"></div>
                <span v-else-if="item.heading" class="dropdown-item-text text-muted">{{ item.heading }}</span>
                <a v-else href class="dropdown-item" :class="item.classes" @click.prevent.stop="onItemClick(item)">
                    <i v-if="item.icon" :class="item.icon"></i>{{ item.label }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['items'],
    data() {
        return {
            open: false,
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, true)
    },
    methods: {
        toggle() {
            if (this.open) {
                this.close()
            } else {
                this.openMenu()
            }
        },
        openMenu() {
            this.open = true
            this.$nextTick(() => {
                document.addEventListener('click', this.handleOutsideClick, true)
            })
        },
        close() {
            this.open = false
            document.removeEventListener('click', this.handleOutsideClick, true)
        },
        handleOutsideClick(e) {
            // Clicks on this menu's own trigger are ignored here — toggle handles them.
            // Clicks anywhere else (including another row's trigger) close the menu.
            const triggerEl = this.$refs.trigger
            const menuEl = this.$refs.menu
            if (triggerEl && triggerEl.contains(e.target)) return
            if (menuEl && menuEl.contains(e.target)) return
            this.close()
        },
        onItemClick(item) {
            if (item.callback) {
                item.callback()
            }
            this.close()
        },
    },
}
</script>
